import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AllMaterialModule } from "../../all-material.components";
import SharedModule from "../../shared/shared.module";
import { CoreModule } from "../../core/core.module";
import { ServicesModule } from "../../services/services.module";
import { FlexLayoutModule } from "@angular/flex-layout";
import { ComponentsModule } from "../../components/components.installer";
import { MatDatepickerModule } from "@angular/material";
import { MaterialTimeControlModule } from "angular-material-time-control";
import { UIRouterModule } from "@uirouter/angular";
import { ActivitiesSharedModule } from "../shared/activities-shared.module";
import { AdjustmentsComponent } from "./adjustments.component";
import { AdjustmentComponent } from "./adjustment.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AllMaterialModule,
        SharedModule,
        CoreModule,
        ServicesModule,
        FlexLayoutModule,
        ComponentsModule,
        MatDatepickerModule,
        MaterialTimeControlModule,
        UIRouterModule,
        ActivitiesSharedModule,
        ReactiveFormsModule
    ],
    declarations: [
        AdjustmentsComponent,
        AdjustmentComponent
    ],
    exports: [
        AdjustmentsComponent,
        AdjustmentComponent
    ]
})
export class ActivityAdjustmentsModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/activities/adjustments/activity-adjustments.module.ts